import { required } from 'vuelidate/lib/validators'
import validatorsByFields from '@/utils/validations/validatorsByFields'
import {
  slugAsyncValidator,
  slugValidator,
  validationErrorMessages
} from '@/utils/validations/validations'
import touristAgenciesQuery from '@/services/gql/types/TouristAgencies/queries/touristAgenciesSlug.gql'

const { name, description } = validatorsByFields
export default ({ id, ctx, isNew }) => {
  const isUnique = async value => {
    return await slugAsyncValidator(
      value,
      id,
      touristAgenciesQuery,
      ctx,
      'touristAgencies'
    )
      .then(res => res)
      .catch(err => console.log(err))
  }
  return {
    organizerName: {
      ...name
    },
    description: {
      ...description,
      required: { validator: required, message: validationErrorMessages.required }
    },
    shortDescription: {
      ...description,
      required: { validator: required, message: validationErrorMessages.required }
    },
    slug: (() => {
      if (isNew) { return false }
      return {
        required: { validator: required, message: validationErrorMessages.required },
        generalValidation: {
          validator: slugValidator,
          message: validationErrorMessages.slugGeneralMsg
        },
        isUnique: { validator: isUnique, message: validationErrorMessages.unique }
      }
    })()
  }
}
